import { Colors } from "../constants/colors";

export default {
  styleOverrides: {
    root: {
      "&.MuiSlider-root": {
        color: Colors.BLUE300,
        borderRadius: 4,
        height: 6,
        "&:not(.MuiSlider-trackInverted)": {
          "& .MuiSlider-track": {
            backgroundColor: Colors.BLUE300,
          },
          "& .MuiSlider-rail": {
            backgroundColor: Colors.GREY200,
          },
        },
        "& .MuiSlider-thumb": {
          "&:hover": {
            boxShadow: "0px 0px 0px 8px rgba(135,	211,	242, .3)",
          },
          "&.Mui-active": {
            boxShadow: "0px 0px 0px 10px rgba(135,	211,	242, .3)",
          },
        },
        "&.MuiSlider-trackInverted": {
          "& .MuiSlider-track": {
            backgroundColor: Colors.GREY200,
            border: "none",
          },
        },
        "&.Mui-disabled": {
          color: Colors.GREY200,
          "& .MuiSlider-thumb": {
            backgroundColor: Colors.GREY350,
          },
          "& .MuiSlider-track": {
            backgroundColor: Colors.GREY350,
          },
          "& .MuiSlider-rail": {
            backgroundColor: Colors.GREY200,
          },
        },
      },
    },
  },
};
